// extracted by mini-css-extract-plugin
module.exports = {"usersWrapper":"users_usersWrapper__15Sg7","usersInfo":"users_usersInfo__14gLx","heading":"users_heading__1KRlN"};